import {useTheme} from '@primer/react-brand/esm'
import {clsx} from 'clsx'

import type {CopyData} from '../../../Index.data'
import type {DataMarqueeEventData} from '../../generic/DataMarquee/DataMarquee'
import type {FeaturedRepository} from '../../generic/MonaFooter/MonaFooter'
import {CtaBannerSection} from '../../sections/CtaBannerSection/CtaBannerSection'
import {CustomerStoriesSection} from '../../sections/CustomerStoriesSection/CustomerStoriesSection'
import {DataMarqueeSection} from '../../sections/DataMarqueeSection/DataMarqueeSection'
import {FeaturesSection} from '../../sections/FeaturesSection/FeaturesSection'
import {FooterSection} from '../../sections/FooterSection/FooterSection'
import {HeroSection} from '../../sections/HeroSection/HeroSection'
import {IntroSection} from '../../sections/IntroSection/IntroSection'
import {ShowcaseSection} from '../../sections/ShowcaseSection/ShowcaseSection'
import {TestimonialsSection} from '../../sections/TestimonialsSection/TestimonialsSection'

import Styles from './HomeView.module.css'

export interface HomeViewRuntimeData {
  isLoggedIn: boolean
  isOrgAdmin: boolean
  recentEvents: DataMarqueeEventData[]
  featuredRepositories: FeaturedRepository[]
}

export interface HomeViewProps {
  copy: CopyData
  runtime: HomeViewRuntimeData
}

export const defaultProps: Partial<HomeViewProps> = {}

export const HomeView = (props: HomeViewProps) => {
  const initializedProps: HomeViewProps = {...defaultProps, ...props}
  const {copy, runtime} = initializedProps
  const {colorMode} = useTheme()
  const isDark = colorMode === 'dark'

  return (
    <div className={clsx(Styles['HomeView'], Styles['HomeView--palette'])} data-color-mode={colorMode}>
      <IntroSection
        {...copy.intro}
        loggedIn={runtime.isLoggedIn}
        isOrgAdmin={runtime.isOrgAdmin}
        monaHead={{...copy.intro.monaHead, variant: isDark ? 'purple' : 'black'}}
      />
      <HeroSection {...copy.hero} />
      <DataMarqueeSection {...copy.dataMarquee} events={runtime.recentEvents} />
      {copy.showcase && <ShowcaseSection {...copy.showcase} />}
      <FeaturesSection {...copy.features} />
      <CtaBannerSection
        {...copy.ctaBanner}
        monaDivider={{...copy.ctaBanner.monaDivider, variant: isDark ? 'purple' : 'black'}}
      />
      <TestimonialsSection {...copy.testimonials} />
      <CustomerStoriesSection {...copy.customerStories} />
      <FooterSection
        {...copy.footer}
        monaFooter={{
          mona: {...copy.footer.monaFooter.mona, variant: isDark ? 'purple' : 'dark'},
          repos: {...copy.footer.monaFooter.repos, items: runtime.featuredRepositories},
        }}
      />
    </div>
  )
}
